import { useCallback } from 'react';

import {
   MedicalDataAccessAuthorization,
   Patient,
   ValidMedicalDataAccessAuthorizationQuery,
} from '@dreryk/egabinet-patient-frontend-api';
import { PatientId } from '@dreryk/egabinet-patient-published-language-api';

import { refetchCqrsQuery, UseCqrsQueryResult, useCqrsSearch } from '@dreryk/command-query-react-common';
import { Direction, paginations } from '@dreryk/command-query-ws-client';

export const useMedicalDataAccessAuthorization = (
   patientId: Patient['id']
): UseCqrsQueryResult<MedicalDataAccessAuthorization[]> => {
   return useCqrsSearch(() => {
      const query = new ValidMedicalDataAccessAuthorizationQuery();
      query.patientId = PatientId.of(patientId);
      return query;
   }, paginations.all<MedicalDataAccessAuthorization>().orderedBy('enterDate', Direction.DESCENDING));
};

export const useRefetchMedicalDataAccessAuthorization = (): (() => Promise<void>) => {
   return useCallback(async (): Promise<void> => {
      await refetchCqrsQuery(ValidMedicalDataAccessAuthorizationQuery);
   }, []);
};
